import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {getReferrer} from "@arboxappv4/shared/src/helpers/functions";
import {
    getAppLink, getBoxData, getWhitelabelProps,
    setIdentifier, setIsKiosk,
    setReferrer, setSelectedLocation,
    setWhitelabel
} from "@arboxappv4/shared/src/redux/siteSlice";
import {addFiltersToQueryParams, getIdentifierFromSubDomain, removePropFromQueryParams} from "../functions";
import {fetchUserMembershipsByBox, setActiveUsersBoxes} from "@arboxappv4/shared/src/redux/userSlice";
import {useParams, useNavigate, useSearchParams} from "react-router-dom";
import useTabName from "./useTabName";
import {PLUGIN_REFERER} from "@arboxappv4/shared/src/constants/constants";
import useOneTimeLink from "./useOneTimeLink";

const useSiteQueryParams = (props) => {
    const { langReady } = props;
    const box = useSelector(state => state.site.box)
    const selectedLocation = useSelector(state => state.site.selectedLocation)
    const user = useSelector(state => state.user.data)
    const userBox = useSelector(state => state.user.activeUsersBoxes)
    const siteWhitelabel = useSelector(state => state.site.whitelabel)
    const siteReferrer = useSelector(state => state.site.referrer)
    const [searchParams] = useSearchParams();
    const params = useMemo(() => Object.fromEntries([...searchParams]), [searchParams]);
    const dispatch = useDispatch()
    const { id } = useParams();
    const navigate = useNavigate();
    useTabName({langReady})
    useOneTimeLink({linkUUID: params.uuid})

    useEffect(() => {
        const whitelabel = params.whitelabel;
        const referrer = params.referrer;
        const location = params.location
        const kiosk = params.kiosk
        const identifier = getIdentifierFromSubDomain()
        dispatch(setIsKiosk(kiosk === 'true'))
        dispatch(setIdentifier(identifier))
        dispatch(getBoxData({identifier, location}))
        dispatch(getWhitelabelProps())
        addFiltersToQueryParams(navigate, {whitelabel: whitelabel ?? siteWhitelabel, referrer: referrer ?? siteReferrer})

        if(referrer) {
            const referrer = getReferrer(params.referrer)
            dispatch(setReferrer(referrer))
            if(params.overrideLocation && referrer.toUpperCase() !== PLUGIN_REFERER) {
                removePropFromQueryParams(navigate, 'overrideLocation')
            }
        }
        if(whitelabel || (!whitelabel && identifier)) {
            dispatch(setWhitelabel(whitelabel || 'Arbox'))
            dispatch(getAppLink())
        }

    }, []);

    useEffect(() => {
        if(box && user) {
            const users_boxes = user.users_boxes.find((item => item.box_fk === box.id));
            if(users_boxes.id !== userBox?.id) {
                dispatch(setActiveUsersBoxes(users_boxes))
                dispatch(fetchUserMembershipsByBox({boxId: box.id, active: true}))
                if (!params.location) {
                    const location = box.locations_box.find(l => l.id === users_boxes.locations_box_fk)
                    dispatch(setSelectedLocation(location))
                }
            }
        }
    }, [box, user]);

    useEffect(() => {
        if(selectedLocation) {
            addFiltersToQueryParams(navigate, {location: selectedLocation.id}) //update query string when location is changed, according to store data
        }
    }, [selectedLocation]);

};

export default useSiteQueryParams;